@if (vm$ | async; as vm) {
  <mat-form-field>
    <input matInput placeholder="Navn" [value]="vm.navn" aria-label="Navn" aria-disabled="true" disabled />
  </mat-form-field>
}
